/* WEYZ product-card photo gallery. Loaded once site-wide; supports AJAX recommendations. */
(() => {
  if (window.weyzProductSwipeInstalled) return;
  window.weyzProductSwipeInstalled = true;
  const selector = '.product-card-wrapper, .wpm-item';
  const states = new WeakMap();
  const coarse = matchMedia('(any-pointer: coarse)');
  const fr = document.documentElement.lang.toLowerCase().startsWith('fr');
  const style = document.createElement('style');
  style.id = 'weyz-product-swipe-style';
  style.dataset.version = '2026-10-16-models';
  style.textContent = `
    .product-card-wrapper .card:not(.card--horizontal) .card__inner:has(.card__media img) { --ratio-percent:133.333333% !important; background:#fff; }
    .product-card-wrapper .card__media, .product-card-wrapper .card__media .media { background:#fff; }
    .product-card-wrapper .card__media .media > img { object-fit:contain; transform:none; }
    .weyz-gallery-layer { display:none !important; position:absolute; inset:0; width:100%; height:100%; background:#fff; pointer-events:none; }
    .weyz-gallery-layer img { display:block; width:100%; height:100%; object-fit:contain !important; object-position:center; }
    :is(.product-card-wrapper,.wpm-item).weyz-gallery-touch :is(.media,.wpm-media) > img { opacity:0 !important; }
    :is(.product-card-wrapper,.wpm-item).weyz-gallery-touch .weyz-gallery-layer { display:block !important; opacity:1 !important; }
    .weyz-gallery-status { position:absolute; width:1px; height:1px; overflow:hidden; clip-path:inset(50%); white-space:nowrap; }
    .weyz-gallery-hitarea { display:none; }
    @media (any-pointer:coarse) {
      .weyz-gallery-ready .card__inner { position:relative; z-index:2; }
      .weyz-gallery-ready .weyz-gallery-hitarea { display:block; position:absolute; inset:0; z-index:3; touch-action:pan-y pinch-zoom; -webkit-tap-highlight-color:transparent; }
      .weyz-gallery-ready .wpm-media { touch-action:pan-y pinch-zoom; }
    }
  `;
  document.head.append(style);
  const key = src => { try { return new URL(src, location.href).pathname; } catch { return src; } };
  const cardFor = target => target instanceof Element ? target.closest(selector) : null;
  const photosFor = (card, media) => {
    const native = [...media.querySelectorAll(':scope > img')];
    if (!native.length) return [];
    const describe = img => ({src:img.getAttribute('src') || img.currentSrc, srcset:img.getAttribute('srcset') || '', alt:img.alt, width:img.width, height:img.height});
    // Keep the initial photo (including an explicitly chosen model photo), then Shopify order.
    const template = card.querySelector('template[data-weyz-card-gallery]');
    const gallery = template ? [...template.content.querySelectorAll('[data-src]')].map(el=>({...el.dataset})) : native.map(describe);
    const first = describe(native[0]);
    const seen = new Set();
    return [first, ...gallery, ...native.slice(1).map(describe)].filter(photo => {
      if (!photo.src || seen.has(key(photo.src))) return false;
      seen.add(key(photo.src)); return true;
    });
  };
  function init(card) {
    if (states.has(card)) return states.get(card);
    const media = card.querySelector('.card__media .media, .wpm-media');
    if (!media) return null;
    const photos = photosFor(card, media);
    if (photos.length < 2) return null;
    const sizes = media.querySelector('img').getAttribute('sizes') || '(min-width:990px) 25vw, 50vw';
    const layer = document.createElement('span'); layer.className='weyz-gallery-layer';
    const initial = media.querySelector('img').cloneNode();
    initial.removeAttribute('id'); initial.removeAttribute('class');
    if(card.matches('.wpm-item'))initial.dataset.wpmSelected='true';
    layer.append(initial); media.append(layer);
    // The theme stretches the title link over the whole card. Give the photo its
    // own touch target so the title/price can still scroll a surrounding carousel.
    const inner=card.querySelector('.card__inner');
    const productLink=card.querySelector('.card__heading a[href]');
    if(inner && productLink){
      const hit=document.createElement('a');hit.className='weyz-gallery-hitarea';
      hit.href=productLink.href;hit.tabIndex=-1;hit.setAttribute('aria-hidden','true');
      if(productLink.target)hit.target=productLink.target;
      if(productLink.rel)hit.rel=productLink.rel;
      inner.append(hit);
    }
    const status=document.createElement('span');status.className='weyz-gallery-status';status.setAttribute('aria-live','polite');
    card.append(status);
    card.classList.add('weyz-gallery-ready');
    const state={card,media,photos,sizes,layer,initial,status,index:0,wanted:0,token:0,cache:new Map()};
    states.set(card,state);return state;
  }
  function load(state,index) {
    if (state.cache.has(index)) return state.cache.get(index);
    const photo=state.photos[index];
    const image=new Image();image.alt=photo.alt || '';image.decoding='async';image.sizes=state.sizes;
    if(index===0 && state.card.matches('.wpm-item'))image.dataset.wpmSelected='true';
    const pending=new Promise((resolve,reject)=>{
      image.onload=()=>resolve(image);image.onerror=()=>{state.cache.delete(index);reject(new Error('Photo unavailable'));};
    });
    state.cache.set(index,pending);
    if (photo.srcset) image.srcset=photo.srcset;
    image.src=photo.src;
    return pending;
  }
  function warm(state,index) {
    if(index>=0 && index<state.photos.length) load(state,index).catch(()=>{});
  }
  function touchMode(state) {
    state.card.classList.add('weyz-gallery-touch');
    warm(state,Math.min(state.wanted+1,state.photos.length-1));
  }
  function show(state,index) {
    index=Math.max(0,Math.min(state.photos.length-1,index));
    state.wanted=index;const token=++state.token;
    touchMode(state);
    load(state,index).then(image=>{
      if(token!==state.token || !state.card.isConnected) return;
      state.layer.replaceChildren(image);state.index=index;
      state.status.textContent=`Photo ${index+1}/${state.photos.length}`;
      warm(state,index+1);
    }).catch(()=>{
      if(token!==state.token) return;
      state.wanted=state.index;
      state.status.textContent=fr?'Photo indisponible. Réessaie.':'Photo unavailable. Try again.';
    });
  }
  let gesture=null, blocked=null, touchGesture=null, lastTouchTime=-Infinity;
  const pointers=new Set();
  function release(){
    if(gesture?.state.card.hasPointerCapture(gesture.id)) gesture.state.card.releasePointerCapture(gesture.id);
    gesture=null;
  }
  const isTouch=e=>e.pointerType==='pen';
  function mouseMode(card){
    if(!card || performance.now()-lastTouchTime<1000) return;
    card.classList.remove('weyz-gallery-touch');
    const state=states.get(card);
    if(state){state.token++;state.index=state.wanted=0;state.layer.replaceChildren(state.initial);state.status.textContent='';}
  }
  // Handle finger gestures directly. In nested carousels, mobile browsers may
  // cancel pointer events as soon as they start interpreting native scrolling.
  document.addEventListener('touchstart',event=>{
    lastTouchTime=performance.now();blocked=null;touchGesture=null;release();
    if(event.touches.length!==1)return;
    const card=cardFor(event.target);if(!card)return;
    const state=init(card);if(!state)return;
    const point=event.touches[0],r=state.media.getBoundingClientRect();
    if(point.clientX<r.left||point.clientX>r.right||point.clientY<r.top||point.clientY>r.bottom)return;
    touchMode(state);
    touchGesture={state,id:point.identifier,x:point.clientX,y:point.clientY,horizontal:false};
  },{capture:true,passive:true});
  document.addEventListener('touchmove',event=>{
    lastTouchTime=performance.now();
    if(!touchGesture)return;
    if(event.touches.length!==1){touchGesture=null;return;}
    const point=event.touches[0];if(point.identifier!==touchGesture.id)return;
    const dx=point.clientX-touchGesture.x,dy=point.clientY-touchGesture.y;
    if(!touchGesture.horizontal){
      if(Math.abs(dy)>6&&Math.abs(dy)>=Math.abs(dx)){touchGesture=null;return;}
      if(Math.abs(dx)<6||Math.abs(dx)<=Math.abs(dy)*1.3)return;
      touchGesture.horizontal=true;
    }
    if(event.cancelable)event.preventDefault();
    event.stopPropagation();
  },{capture:true,passive:false});
  document.addEventListener('touchend',event=>{
    lastTouchTime=performance.now();
    if(!touchGesture)return;
    const point=[...event.changedTouches].find(t=>t.identifier===touchGesture.id);
    if(!point)return;
    const current=touchGesture;touchGesture=null;
    if(!current.horizontal)return;
    const dx=point.clientX-current.x,state=current.state;
    if(Math.abs(dx)>=30)show(state,state.wanted+(dx<0?1:-1));
    blocked={card:state.card,until:performance.now()+700};
    if(event.cancelable)event.preventDefault();
    event.stopPropagation();
  },{capture:true,passive:false});
  document.addEventListener('touchcancel',()=>{touchGesture=null;lastTouchTime=performance.now();},{capture:true,passive:true});
  document.addEventListener('pointerdown',event=>{
    if(event.pointerType==='touch')return;
    blocked=null;
    if(!isTouch(event)){mouseMode(cardFor(event.target));return;}
    pointers.add(event.pointerId);release();
    if(pointers.size!==1||!event.isPrimary) return;
    const card=cardFor(event.target);if(!card)return;
    const state=init(card);if(!state)return;
    const r=state.media.getBoundingClientRect();
    if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)return;
    touchMode(state);
    gesture={state,id:event.pointerId,x:event.clientX,y:event.clientY,horizontal:false};
  },{capture:true,passive:true});
  document.addEventListener('pointermove',event=>{
    if(!gesture||gesture.id!==event.pointerId)return;
    const dx=event.clientX-gesture.x,dy=event.clientY-gesture.y;
    if(!gesture.horizontal){
      if(Math.abs(dy)>10&&Math.abs(dy)>=Math.abs(dx)){release();return;}
      if(Math.abs(dx)<12||Math.abs(dx)<=Math.abs(dy)*1.3)return;
      gesture.horizontal=true;gesture.state.card.setPointerCapture(event.pointerId);
    }
    if(event.cancelable)event.preventDefault();event.stopPropagation();
  },{capture:true,passive:false});
  document.addEventListener('pointerup',event=>{
    pointers.delete(event.pointerId);
    if(!gesture||gesture.id!==event.pointerId)return;
    if(gesture.horizontal){
      const {state}=gesture, dx=event.clientX-gesture.x;
      if(Math.abs(dx)>=30)show(state,state.wanted+(dx<0?1:-1));
      blocked={card:state.card,until:performance.now()+700};
      if(event.cancelable)event.preventDefault();event.stopPropagation();
    }release();
  },{capture:true,passive:false});
  document.addEventListener('pointercancel',event=>{pointers.delete(event.pointerId);if(gesture?.id===event.pointerId)release();},{capture:true,passive:true});
  document.addEventListener('click',event=>{
    if(!blocked)return;
    const last=blocked;blocked=null;
    if(performance.now()<=last.until&&cardFor(event.target)===last.card&&event.detail!==0){event.preventDefault();event.stopImmediatePropagation();}
  },true);
  // Changing the section view also resets its swipe galleries to the selected photo.
  document.addEventListener('click',event=>{
    const button=event.target instanceof Element?event.target.closest('[data-wpm-toggle]'):null;
    if(!button)return;
    const root=button.closest('[data-wpm-root]');if(!root)return;
    const mode=root.dataset.wpmMode==='models'?'packshot':'models';
    root.dataset.wpmMode=mode;button.setAttribute('aria-checked',String(mode==='models'));
    root.querySelectorAll('.wpm-item').forEach(card=>{
      const views=card.querySelector('template[data-wpm-views]');
      const primary=card.querySelector('.wpm-media > .wpm-primary');
      if(!views||!primary)return;
      const apply=(image,view)=>{
        const photo=views.content.querySelector(`[data-view="${view}"]`);if(!image||!photo)return;
        image.removeAttribute('srcset');
        image.alt=photo.dataset.alt||'';
        for(const attr of ['width','height'])if(photo.dataset[attr])image.setAttribute(attr,photo.dataset[attr]);
        if(photo.dataset.srcset)image.srcset=photo.dataset.srcset;
        image.src=photo.dataset.src;
      };
      const state=states.get(card);
      if(state){
        state.token++;
        if(gesture?.state===state)release();
        if(touchGesture?.state===state)touchGesture=null;
        state.layer.remove();state.status.remove();states.delete(card);
      }
      card.classList.remove('weyz-gallery-ready','weyz-gallery-touch');
      apply(primary,mode);
      apply(card.querySelector('.wpm-media > .wpm-packshot'),mode==='models'?'packshot':'models');
      if(coarse.matches)init(card);
    });
  });
  document.addEventListener('pointerover',event=>{if(event.pointerType==='mouse')mouseMode(cardFor(event.target));},{passive:true});
  window.addEventListener('blur',()=>{release();touchGesture=null;pointers.clear();blocked=null;});
  // Prepare gestures on touch devices, including recommendations and filtered results inserted later.
  function discover(root){
    if(!coarse.matches)return;
    if(root instanceof Element && root.matches(selector))init(root);
    root.querySelectorAll?.(selector).forEach(init);
    if(root instanceof Element){const parent=root.closest(selector);if(parent)init(parent);}
  }
  discover(document);
  new MutationObserver(records=>{for(const record of records)for(const node of record.addedNodes)if(node instanceof Element)discover(node);}).observe(document.body,{childList:true,subtree:true});
  coarse.addEventListener('change',()=>discover(document));
})();
